<template>
  <v-card>
    <v-card-title>
      Customer - {{ propCustomer.name }}

      <div class="flex-grow-1"></div>

      <v-btn icon @click="$emit('editMode')">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row v-for="(value, key) in propCustomer" :key="key">
        <v-col class="text-right font-weight-light" v-if="!excludedFields.includes(key)">{{ key }}</v-col>
        <v-col class="text-left font-weight-bold" v-if="!excludedFields.includes(key)">{{ value }}</v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ShowCustomer',

  props: ['propCustomer'],

  data: () => ({
    excludedFields: [
      'Items'
    ]
  })
}
</script>
